import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'nsc-card-title-error',
    templateUrl: './card-title-error.component.html',
    styleUrls: ['./card-title-error.component.scss'],
    standalone: false
})
export class CardTitleErrorComponent implements OnInit {
  @Input('title') title!: string;
  @Input('icon') icon!: string;
  @Input('headingLevel') headingLevel: 1 | 2 | 3 | 4 | 5 | 6 = 5;
  constructor() { }

  ngOnInit() {
  }

}
